import { render } from "./DuplicationResultModal.vue?vue&type=template&id=4e9d3c9e&ts=true"
import script from "./DuplicationResultModal.vue?vue&type=script&lang=ts"
export * from "./DuplicationResultModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__